import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorMessageProps {
  message?: string;
  className?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, className = '' }) => {
  if (!message) return null;

  return (
    <div className={`flex items-center gap-1 text-red-600 text-xs mt-1 ${className}`}>
      <AlertCircle size={14} />
      <span>{message}</span>
    </div>
  );
};
